'use client'
import { lastAuthenticatedAccount } from '../../functions/lastAuthenticatedAccount/index.js';

const useGlobalLoading = ({ authMode, connectedInfo, connectedWallets, projectSettings, primaryWallet, user, walletBook, }) => {
    var _a, _b;
    const isPrimaryWalletLoading = user &&
        ((_a = lastAuthenticatedAccount(user)) === null || _a === void 0 ? void 0 : _a.format) === 'blockchain' &&
        !primaryWallet;
    const isConnectOnlyWalletsLoading = authMode === 'connect-only' &&
        connectedInfo &&
        connectedWallets.length === 0;
    const hasWalletBookLoaded = Boolean(Object.keys((_b = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _b !== void 0 ? _b : {}).length);
    if (!hasWalletBookLoaded ||
        !projectSettings ||
        isPrimaryWalletLoading ||
        isConnectOnlyWalletsLoading)
        return false;
    return true;
};

export { useGlobalLoading };
